import { PageType } from "shared/lib/page-type";

export const pathname = "/podcasts";

export const page = {
  route(query: QueryParameters) {
    return {
      pathname,
      query: { ...query, pageType: PageType.Section },
    };
  },
};
